// extracted by mini-css-extract-plugin
module.exports = {"overlay":"tutorial_overlay__1Fj9v","container":"tutorial_container__2x6t_","close":"tutorial_close__1t6Ja","link":"tutorial_link__yW_yW"};